<template>
  <path
    d="M19.23 15.2602L16.69 14.9702C16.08 14.9002 15.48 15.1102 15.05 15.5402L13.21 17.3802C10.38 15.9402 8.06004 13.6302 6.62004 10.7902L8.47004 8.94019C8.90004 8.51019 9.11004 7.91019 9.04004 7.30019L8.75004 4.78019C8.63004 3.77019 7.78004 3.01019 6.76004 3.01019H5.03004C3.90004 3.01019 2.96004 3.95019 3.03004 5.08019C3.56004 13.6202 10.39 20.4402 18.92 20.9702C20.05 21.0402 20.99 20.1002 20.99 18.9702V17.2402C21 16.2302 20.24 15.3802 19.23 15.2602Z"
  />
</template>
